import { InputField, Form } from "@made-people/blueprint-form";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { useRegisterForm } from "../hooks/use-register-form";
import { useGeneralSettings } from "../../../hooks/use-general-settings";
import { ErrorMessage } from "./ErrorMessage";

type RegisterFormProps = {
  form: ReturnType<typeof useRegisterForm>;
  loginAction: React.ReactNode;
};

export const RegisterForm = ({ form, loginAction }: RegisterFormProps) => {
  const translate = useTranslate();
  const generalSettings = useGeneralSettings();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2 md:gap-4">
        <h2 className="text-heading-sm">
          {translate("Account_Signup_Heading")}
        </h2>
        <p className="text-body-md">{translate("Account_Signup_Lead")}</p>
      </div>
      <Form>
        <InputField
          template="floating-label"
          type="text"
          label={translate("Form_Field_FirstName")}
          placeholder={translate("Form_Field_FirstName")}
          value={form.firstName}
          onChange={(e) => {
            form.setFirstName(e.target.value);
            form.clearFieldError("firstName");
          }}
          onKeyDown={form.handleKeyDown}
          helperText={
            form.errors.firstName
              ? { text: form.errors.firstName, type: "error" }
              : undefined
          }
        />
        <InputField
          template="floating-label"
          type="text"
          label={translate("Form_Field_LastName")}
          placeholder={translate("Form_Field_LastName")}
          value={form.lastName}
          onChange={(e) => {
            form.setLastName(e.target.value);
            form.clearFieldError("lastName");
          }}
          onKeyDown={form.handleKeyDown}
          helperText={
            form.errors.lastName
              ? { text: form.errors.lastName, type: "error" }
              : undefined
          }
        />
        <InputField
          template="floating-label"
          type="email"
          label={translate("Form_Field_Email")}
          placeholder={translate("Form_Field_Email")}
          value={form.email}
          onChange={(e) => {
            form.setEmail(e.target.value);
            form.clearFieldError("email");
          }}
          onKeyDown={form.handleKeyDown}
          helperText={
            form.errors.email
              ? { text: form.errors.email, type: "error" }
              : undefined
          }
        />
        <InputField
          template="floating-label"
          type="password"
          label={translate("Form_Field_Password")}
          placeholder={translate("Form_Field_Password")}
          value={form.password}
          onChange={(e) => {
            form.setPassword(e.target.value);
            form.clearFieldError("password");
          }}
          onKeyDown={form.handleKeyDown}
          helperText={
            form.errors.password
              ? { text: form.errors.password, type: "error" }
              : undefined
          }
        />
        {generalSettings?.termsAndConditionText?.gearsResolvedRichText ? (
          <div
            className="text-body-sm text-text-less-emphasis-1 [&_a]:underline mb-4"
            dangerouslySetInnerHTML={{
              __html:
                generalSettings.termsAndConditionText.gearsResolvedRichText,
            }}
          />
        ) : (
          <p className="text-body-sm text-text-less-emphasis-1 mb-4">
            {translate("Account_Signup_TermsAndConditions")}
          </p>
        )}
        <ErrorMessage error={form.errors.general} />
        <div className="flex flex-col gap-4">
          <ButtonAsButton
            label={translate("Account_Signup_PrimaryAction")}
            onClick={form.handleSubmit}
            progress={form.loadingState}
            variants={{ width: "full" }}
          />
          {loginAction}
        </div>
      </Form>
    </div>
  );
};
